import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../api';

const MessagesContext = createContext(null);

export function MessagesProvider({ children }) {
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnreadCount = useCallback(async () => {
    try {
      const { unreadCount: count } = await api.getMessagesUnreadCount();
      setUnreadCount(typeof count === 'number' ? count : 0);
    } catch {
      setUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refreshUnreadCount();
    const intervalId = setInterval(refreshUnreadCount, 15000);
    return () => clearInterval(intervalId);
  }, [refreshUnreadCount]);

  return (
    <MessagesContext.Provider value={{ unreadCount, refreshUnreadCount }}>
      {children}
    </MessagesContext.Provider>
  );
}

export function useMessages() {
  const ctx = useContext(MessagesContext);
  if (!ctx) {
    throw new Error('useMessages must be used within MessagesProvider');
  }
  return ctx;
}
